import * as React from 'react';
import {Query} from 'react-apollo';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CoreEntity as CoreEntityFragment,
    GetCoreEntity as GetCoreEntityQuery,
    GetCoreEntityVariables as GetCoreEntityQueryVariables,
} from 'nutshell-graphql-types';

import GET_CORE_ENTITY from './graphql/queries/get-core-entity.graphql';

type ComponentProps = OwnProps & {
    entity: CoreEntityFragment | null | undefined;
    onRefetchEntity: () => any;
};

class GetEntityComponent extends React.PureComponent<ComponentProps> {
    componentDidMount() {
        $(window).on('entityWasEdited', this.refetchEntity);

        // Leads have additional events we need to check for
        if (typeof Lead !== 'undefined' && Lead.events) {
            $(window).on(Lead.events.LeadBackboneModelDidUpdate, this.refetchEntity);
        }
    }

    componentWillUnmount() {
        $(window).off('entityWasEdited', this.refetchEntity);

        // Leads have additional events we need to check for
        if (typeof Lead !== 'undefined' && Lead.events) {
            $(window).off(Lead.events.LeadBackboneModelDidUpdate, this.refetchEntity);
        }
    }

    render() {
        if (!this.props.entity) {
            return null;
        }

        return this.props.children({
            entity: this.props.entity,
        });
    }

    refetchEntity = () => {
        this.props.onRefetchEntity();
    };
}

type OwnProps = {
    entityId: string;
    children: (arg1: {entity: CoreEntityFragment}) => React.ReactElement;
};

class GetEntityQuery extends Query<GetCoreEntityQuery, GetCoreEntityQueryVariables> {}

export const GetEntity = (props: OwnProps) => (
    <GetEntityQuery query={GET_CORE_ENTITY} variables={{id: props.entityId}}>
        {({data, refetch, error}) => {
            const coreEntity = data ? data.coreEntity : null;

            return (
                <GetEntityComponent
                    {...props}
                    entity={coreEntity}
                    onRefetchEntity={refetch}
                    // @ts-expect-error
                    entityErrorMessage={safelyGetGraphQLErrorMessage(error)}
                >
                    {props.children}
                </GetEntityComponent>
            );
        }}
    </GetEntityQuery>
);
